<template>
  <div class="question-view hotspot" >
    <FixedFontSizeSelector style="width: 50%;">
    <div class="quest">
      <div class="title">
        <vue-mathjax @onRenderComplete="onRenderComplete(++mathjaxNum)" :formula="form.title" :safe="false"/>
      </div>
    </div>
    </FixedFontSizeSelector>
    <div class="box" :style="`${mode == 'viewAnswer' ? `--beforeShow: '';` : `--beforeShow: none;`}`">
      <div class="quest-img" :style="{backgroundImage: `url(${form.img_url})`}">
        <!-- <img :src="form.img_url" alt=""> -->
      </div>
    </div>

  </div>
</template>

<script>
import HotspotDrag from './hotspotDrag/hotspotDrag'
import { _debounce } from '@/utils/throttle.js'
import FixedFontSizeSelector from '@/views/student/components/FontSizeSelector'
export default {
  components: {
    FixedFontSizeSelector
  },
  props: ['form', 'mode'],
  data() {
    let letter = new Array(26).fill().map((its, idx) => its = String.fromCharCode(65 + idx))

    return {
      mathjaxNum: 0,
      letter,
      image: '',
      topic: '',
      map: [],
      hotspotData: [],

      drag: null,
      answer_results: {
        id: null,
        student_choices: []
      },
      recordQuestion: [],
      // 记录答题次数
      limit: 0,

      observer: null,
      firedNum: 0,
      recordOldValue: { // 记录下旧的宽高数据，避免重复触发回调函数
        width: '0',
        height: '0'
      }
    }
  },
  watch: {
    'form.id': {
      handler(){
        this.initData()
      },
      deep: true
    }
  },
  methods: {
    onRenderComplete(i) {
      let num = 1

      if(i == num) {
        this.$parent.loading = false
      }
    },
    // 重置
    resetting() {
      // 数据清空
      this.$emit('permissions', false)
      this.limit = 0

      // 清空样式
      let blocks = document.querySelectorAll('.block-style')
      for(let i = 0; i < blocks.length; i++) {
        let block = blocks[i]
        if(block.dataset.mark == 1) block.click()
      }
    
      this.recordQuestion = []
      this.answer_results = {
        id: null,
        student_choices: []
      }
      this.repariRecordQuestion()
    },
    repariRecordQuestion() {
      this.$emit('repariRecordQuestion', this.recordQuestion, this.limit)
    },
    showTrueFalse() {
      let { form, recordQuestion } = this,
      answers = form.answers.map(its => its.choice_id),
      blocks = document.querySelectorAll('.block-style')

      if(recordQuestion.length == 0) {
        return ;
      }

      this.limit = 1

      for(let i = 0; i < blocks.length; i++) {
        let block = blocks[i],
        {value} = block.dataset
        if(recordQuestion.some(its => its.choice_id == value)) {
          block.click()
        }
      }

      for(let i = 0; i < blocks.length; i++) {
        let block = blocks[i],
        {value, mark} = block.dataset

        if(mark != 1) continue;

        if(this.mode == 'question') {
          continue ;
        }
        if(answers.includes(Number(value))) {
          block.classList.add('block-style-success')
        } else {
          block.classList.add('block-style-error')
        }
      }
    },
    getNodeTotalHeight(dom) {
      if(!dom) return 0

      let styleData = window.getComputedStyle(dom, null)

      return dom.offsetHeight
             + Number(styleData.marginTop.replace('px', '')) 
             + Number(styleData.marginBottom.replace('px', ''))
    },
    sizeEvent() {
      // 获取quest-img宽高比例
      let windowHeight = window.innerHeight,
      header = document.querySelector('.header'),
      mainHeight = document.querySelector('.main-header'),
      viewAnswer = document.querySelector('.viewAnswer-func'),
      title = document.querySelector('.quest .title')
      let imgDom = document.querySelector('.quest-img'),
      
      iWidth = title.clientWidth,
      iHeight = windowHeight 
                - this.getNodeTotalHeight(header)
                - this.getNodeTotalHeight(mainHeight)
                - this.getNodeTotalHeight(viewAnswer)
                - this.getNodeTotalHeight(title)
                - 40 - 30,
      imgBl = 833 / 500

      if(iWidth / imgBl <= iHeight) {
        iHeight = iWidth / imgBl
      } else {
        iWidth = imgBl * iHeight
      }
      
      iHeight = iHeight > 500 ? 500 : iHeight
      iWidth = iWidth > 833 ? 833 : iWidth

      imgDom.style.height = iHeight + 'px'
      imgDom.style.width = iWidth + 'px'
      // 获取block-style宽高
      // let block = document.querySelectorAll('.block-style')
      for(let i = 0; i < this.map.length; i++) {
        let {width, height, x, y, uuid} = this.map[i], 
        block = document.querySelector(`#${uuid}`),
        bl = (iWidth / 833) * 500 / 300
        if(!block) {
          continue ;
        }
        block.style.width = `${width * bl}px`
        block.style.height = `${height * bl}px`
        block.style.top = `${y * bl}px`
        block.style.left = `${x * bl}px`
      }
    },
    initData() {
      this.answer_results = {
        id: null,
        student_choices: []
      }
      this.recordQuestion = []
      this.hotspotData = []

      this.drag = new HotspotDrag({
        plate: '.quest-img',
        useType: 'view',
      })
      let content = JSON.parse(this.form.content)
      console.log(content)
      this.map = []
      for(let i = 0; i < this.form.choices.length; i++) {
        let its = this.form.choices[i]
        this.map.push({
          ...JSON.parse(its.value),
          other: {
            id: its.id,
            position: its.position,
            type: its.type
          }
        })
      }
      this.drag.echoBlock(this.map, this)

      // if(this.mode == 'viewAnswer') 
      setTimeout(() => this.showTrueFalse(), 500)
      this.sizeEvent()
    }
  },
  created() {
    // transfer.$on('hotspot', ({image, topic, hotspotData}) => {
    //   this.image = image
    //   this.topic = topic
    //   this.hotspotData = hotspotData

    //   this.drag && this.drag.echoBlock(hotspotData, this)
    // })
  }, 
  mounted() {
    this.initData()

    window.onresize = _debounce(this.sizeEvent, 500)
  }
}
</script>

<style scoped lang="scss">
@import url('../../static/pubile.scss');

.question-view {
  width: 100%;
  height: 100%;
  padding: 0px;
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  align-content: flex-start;
  justify-content: flex-start;
  border-radius: 10px;
  .quest {
    width: 100%;

    .title {
      font-size: 15px;
      color: #333;
    }

  }

  .box {
    width: 100%;
    flex: 1;

    .quest-img {
  margin-left: 10px;
      max-width: 833px;/*width: 833px;*/
      max-height: 500px;
      width: 100%;
      flex: 100%;
      background-color: #fff;
      background-size: 100% 100%;
      position: relative;
      .img-region {
        position: relative;
        display: flex;
        overflow: hidden;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
  
        span {
          position: absolute;
          background-color: #fff;
          color: #333;
        }
  
        &:after, &:before {
          content: '';
          position: absolute;
          top: 0;
          bottom: 0;
          left: -50%;
          margin: auto;
          height: 1px;
          width: 200%;
          background-color: #fff;
          transform: rotateZ(45deg);
        }
  
        &:before {
          transform: rotateZ(-45deg);
        }
      }
  
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>

<style lang="scss">
  
.click-style {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding: 10px;
  box-sizing: border-box;
  display: none;

  &:before {
    content: '';
    position: absolute;
    top: -5px;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    width: 10px;
    height: 20px;
    border: 3px solid #007516;
    border-top: none;
    border-left: none;
    transform: rotateZ(50deg);
  }
}

.block-style-circle {
  position: absolute;
  top: 80px;
  left: 80px;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  cursor: pointer;
  // z-index: 1;
  background-color: transparent;
  background-size: 100% 100%;
  
  &:before {
    content: '';
    border-radius: 50%;
  }
}

.question-click-style {
  &:before {
    border: none !important;
  }
  .click-style {
    &:after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      margin: auto;
      width: 100%;
      height: 100%;
      border: 3px dashed #007516;
      box-sizing: border-box;
    }
  }
}

.question-click-style.block-style-circle > .click-style:after  {
  content: '';
  border: 3px dashed #007516;
  border-radius: 50%;
  box-sizing: border-box;
}
</style>